import { useTranslation } from 'react-i18next';
import '@fontsource/unifont';
import './post.scss';
import { Box } from '@mui/material';
import { useRef } from 'react';

import Matrix from '../home/canvas/matrix';

export default function Post() {
  const { t } = useTranslation();
  const titleRef = useRef(null);
  return (
    <Box>
      <Box className="scroll-post">
        <Box className="home-container-post">
          <Box
            className="homeContainer-post"
            ref={titleRef}
            style={{
              whiteSpace: 'pre-line',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
              paddingLeft: 5,
            }}
          >
            <Box className="canvasContainer-post">
              <Matrix />
            </Box>
            <Box className="dateTitle-post">
              <h1>{`${t('post.titles.main')}`}</h1>
              {`${t('post.body')}`}
              <br />
              <img
                src="/Imagen 1.png"
                alt="descripcion"
                style={{ maxWidth: '50%', objectFit: 'cover' }}
              />
              <img
                src="/Imagen 2.png"
                alt="descripcion"
                style={{ maxWidth: '50%', objectFit: 'cover' }}
              />
              <h2>{`${t('post.titles.subtitle')}`}</h2>
              {`${t('post.body1')}`}
              <br />
              <img
                src="/Imagen 3.png"
                alt="descripcion"
                style={{ maxWidth: '100%', margin: '8px 0' }}
              />
              <br />
              {`${t('post.body2')}`}
              <br />
              <img
                src="/Imagen 4.png"
                alt="descripcion"
                style={{ maxWidth: '100%', margin: '8px 0' }}
              />
              <h2>{`${t('post.titles.subtitle1')}`}</h2>
              {`${t('post.body3')}`}
              <br />
              <img
                src="/Imagen 5.png"
                alt="descripcion"
                style={{ maxWidth: '100%', margin: '8px 0' }}
              />
              <br />
              {`${t('post.body4')}`}
              <br />
              <img
                src="/Imagen 6.png"
                alt="descripcion"
                style={{ maxWidth: '100%', margin: '8px 0' }}
              />
              <br />
              {`${t('post.body5')}`}
              <h2> {`${t('post.titles.subtitle2')}`}</h2>
              {`${t('post.body6')}`}
              <h2> {`${t('post.titles.subtitle3')}`}</h2>
              {`${t('post.body7')}`}
              <h3> {`${t('post.titles.game')}`}</h3>
              {`${t('post.body8')}`}
              <h3> {`${t('post.titles.game1')}`}</h3>
              {`${t('post.body9')}`}
              <h3> {`${t('post.titles.game2')}`}</h3>
              {`${t('post.body10')}`}
              <h2> {`${t('post.titles.subtitle4')}`}</h2>
              {`${t('post.body11')}`}
              <br />
              <img
                src="/Imagen 7.png"
                alt="descripcion"
                style={{ maxWidth: '100%', margin: '8px 0' }}
              />
              <br />
              {`${t('post.body12')}`}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
